import { Component, OnInit } from '@angular/core';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'down-loads',
  templateUrl: './down-loads.component.html',
  styleUrls: ['./down-loads.component.css']
})
export class DownLoadsComponent implements OnInit {

  constructor(private utilService: UtilitieService){

  }
  ngOnInit(): void {
    this.utilService.updateLoading(false);
  }

}
